import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboardApi'

export function useDashboardQuery(tenantId?: number) {
  const queryKey = useMemo(() => ['dashboard-stats', tenantId], [tenantId])

  return useQuery({
    queryKey,
    queryFn: () => dashboardApi.getStats(tenantId),
    staleTime: 30_000,
    enabled: tenantId != null,
  })
}
